const AppConstants = {
 STATUS_SUCCESS : "SUCCESS" ,
 STATUS_FAILURE : "FAILURE" ,
 ACTION_SAVE : "Save",
 ACTION_UPDATE :"Update",

 PRODUCT_P2P:'1',
 PRODUCT_TNE:'3',
 PRODUCT_RENT_AND_UTILITY:'2',
 PRODUCT_Vendor_Empanlement:'4',
 PRODUCT_ERFX:'6',
 PRODUCT_CMS:'5',
 PRODUCT_ASSET_MANAGMENT:7,


 ACTIVITY_CREATE_USER_ROLE_ID: '1',
 ACTIVITY_EDIT_USER_ROLE_ID: '9',
 ACTIVITY_VIEW_USER_ROLE_ID: '2',

 ACTIVITY_CREATE_TENANT_ROLE_ID: '3',
 ACTIVITY_VIEW_TENANT_ROLE_ID: '4',
 ACTIVITY_MODIFY_TENANT_ROLE_ID: '10',

 ACTIVITY_CREATE_TENANT_USER_ROLE_ID: '6',
 ACTIVITY_MODIFY_TENANT_USER_ROLE_ID: '11',
 ACTIVITY_MANAGE_TENANT_USER_Role_ROLE_ID : '7',


 ACTIVITY_VIEW_MIS_ROLE_ID: '5',
 ACTIVITY_COMPANY_SETTING_ROLE_ID: '8',
 
 
}
export default AppConstants;